import { social } from "../data/site";

const Icon = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-4 w-4"
  >
    {children}
  </svg>
);

const items = [
  {
    href: social.instagram,
    label: "Instagram",
    svg: (
      <Icon>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
      </Icon>
    ),
  },
  {
    href: social.whatsapp,
    label: "WhatsApp",
    svg: (
      <Icon>
        <path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20.5l1.7-5.2A8.5 8.5 0 1 1 21 11.5Z" />
        <path d="M8.5 9.5c0 3 2 5 5 5 .8 0 1.3-.6 1.3-1.2 0-.3-1.4-1-1.7-1-.4 0-.6.6-.9.6-.6 0-2-1.4-2-2 0-.3.6-.5.6-.9 0-.3-.7-1.7-1-1.7-.6 0-1.3.5-1.3 1.2Z" />
      </Icon>
    ),
  },
  {
    href: social.maps,
    label: "Location",
    svg: (
      <Icon>
        <path d="M12 21s7-6 7-11a7 7 0 1 0-14 0c0 5 7 11 7 11Z" />
        <circle cx="12" cy="10" r="2.6" />
      </Icon>
    ),
  },
];

export default function SocialIcons({ className = "", tone = "light" }) {
  // tone="light" → light icons for dark backgrounds (footer)
  // tone="dark"  → dark icons for light backgrounds (Contact page)
  const base =
    tone === "dark"
      ? "border-black/15 text-charcoal/60"
      : "border-white/15 text-cream/70";
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {items.map((it) => (
        <a
          key={it.label}
          href={it.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={it.label}
          className={`flex h-9 w-9 items-center justify-center rounded-full border transition-all duration-300 hover:border-gold hover:text-gold ${base}`}
        >
          {it.svg}
        </a>
      ))}
    </div>
  );
}
